import React from 'react'  
import GooglePexel from "./googlePexel";  
  
function App() {  
  return (  
    <GooglePexel></GooglePexel>  
  )  
}  
  
export default App;  